import { ReactNode } from "react";

export const DEFAULT_VALUES = Object.freeze({
    br: <br />,
    p: (chunks: ReactNode) => <p>{chunks}</p>,
    strong: (chunks: ReactNode) => <strong>{chunks}</strong>,
    span: (chunks: ReactNode) => <span>{chunks}</span>,
    ul: (chunks: React.ReactNode) => <ul>{chunks}</ul>,
    ol: (chunks: React.ReactNode) => <ol>{chunks}</ol>,
    li: (chunks: React.ReactNode) => <li>{chunks}</li>
});
